module.exports = __webpack_public_path__ + "static/media/sword.2317bce5.png";